
export const userKey = 'userInfo'
export const baseApiUrl = process.env.VUE_APP_URL
export const avatarPhoto = 'av'
// export const baseApiUrl = 'https://api.copyjui.com.br'
//import store from './store/store.js'
import axios from "axios"

export async function renewLocalStorage(newToken) {

    try {
       //const json = localStorage.getItem(userKey)
        //const userAuth = JSON.parse(json)
        await axios.post(`${baseApiUrl}/validateToken`, {token:newToken});
        //store.commit("SET_USER_INFO", userAuth);
    } catch (e) {
        console.log(e)
    } 
}  

export default { baseApiUrl, userKey, renewLocalStorage }